/**
 * Es un wrapper para toastr. De momento Usamos directamente el componente que está
 * añadido de forma global a la página
 */
/* global toastr */
import RespuestaErrorApi from '../errores/RespuestaErrorApi';

function showError(mensaje, titulo, opciones) {
  toastr.error(mensaje, titulo, opciones);
}

export default {
  error: showError,
  info(mensaje, titulo, opciones) {
    toastr.info(mensaje, titulo, opciones);
  },
  success(mensaje, titulo, opciones) {
    toastr.success(mensaje, titulo, opciones);
  },
  warning(mensaje, titulo, opciones) {
    toastr.warning(mensaje, titulo, opciones);
  },
  // Para mostrar los errores devueltos por una api. En principio es la api del servidor,
  // habría que ver porque la api de la app creo que devuelve la estructura distinta
  apiErrors(axiosError) {
    const res = new RespuestaErrorApi(axiosError.response.data);
    showError(res.getMensajesError().join('. '));
  },
};
